import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CodeInputModule } from 'angular-code-input';
import { PinCodeInputComponent } from './pin-code-input.component';

@NgModule({
  imports: [CommonModule, CodeInputModule],
  declarations: [PinCodeInputComponent],
  exports: [PinCodeInputComponent],
})
export class PinCodeInputModule {}
